export enum CHARTS_COLUMN {
  HS_CLASS = 'HS Class',
  DIVISION = 'Division',
  TEAM_SELECT = 'Team Select',
  SEC = 'SEC',
  NFL_DRAFT = 'NFL Draft'
}

export const PLAYER_CHARTS_COLUMNS = {
  [CHARTS_COLUMN.HS_CLASS]: 'HS Class',
  [CHARTS_COLUMN.DIVISION]: 'Division',
  [CHARTS_COLUMN.TEAM_SELECT]: 'Team Select',
  [CHARTS_COLUMN.SEC]: 'SEC',
  [CHARTS_COLUMN.NFL_DRAFT]: 'NFL Draft'
}

export const PLAYER_CHARTS_ALL_COLUMNS = [
  CHARTS_COLUMN.HS_CLASS,
  CHARTS_COLUMN.DIVISION,
  CHARTS_COLUMN.TEAM_SELECT,
  CHARTS_COLUMN.SEC,
  CHARTS_COLUMN.NFL_DRAFT
]